import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { appPaths } from "../../shared/routing/appPaths";

/** The way back from an account page (setup, invitation, password reset) to sign-in. */
export default function BackToSignInLink() {
  const { t } = useTranslation();

  return (
    <Link to={appPaths.login()} className="app-link mt-4 inline-block text-sm underline">
      {t("newAccount.backToLogin")}
    </Link>
  );
}
